<div class="header">
  <img src="/assets/logo/logo-busitalia.png"
    alt="Busitalia Logo"
    class="logo">
  <button matIconButton
    color=""
    class="logout-button"
    (click)="onLogout()">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</div>